import React from 'react';
import PropTypes from 'prop-types';

import Item from '../Item/Item';
import { WhiteBox } from 'components/flink-play';
import classes from './QuestionItem.module.scss';

const QuestionItem = ({ data, activityAudioBaseUrl, boxClassName = '', innerClassName = '' }) => {
  return (
    <WhiteBox outerClass={[classes.box, boxClassName].filter(Boolean).join(' ')} innerClass={[classes.inner, innerClassName].filter(Boolean).join(' ')}>
      <Item
        data={data}
        bigger
        activityAudioBaseUrl={activityAudioBaseUrl}
      />
    </WhiteBox>
  );
};

QuestionItem.propTypes = {
  data: PropTypes.object,
  activityAudioBaseUrl: PropTypes.string,
  boxClassName: PropTypes.string,
  innerClassName: PropTypes.string,
};

export default QuestionItem;
